import { connect } from 'react-redux';
import {
    setLocaleTexts,
    setLocale,
    setDealer,
    setIsLoading,
    toggleLanguageMenu,
    toggleSideMenu,
    toggleImprintPopup,
    toggleDataPrivacyPopup,
    toggleBrowserDetectPopup,
} from '../actions/actionCreators/app';
import Layout from '../components/Layout';
import { toggleVisibility as toggleIntroductionLayer } from '../actions/actionCreators/introductionLayer';

function mapStateToProps(state) {
    return {
        isLoading: state.app.isLoading,
        dealer: state.app.dealer,
        lang: state.app.lang,
        isLanguageMenuOpen: state.app.isLanguageMenuOpen,
        isSideMenuOpen: state.app.isSideMenuOpen,
        isImprintPopupOpen: state.app.isImprintPopupOpen,
        isDataPrivacyPopupOpen: state.app.isDataPrivacyPopupOpen,
        isBrowserDetectPopupOpen: state.app.isBrowserDetectPopupOpen,
        sidemenuLinks: {
            // these links are provided because its not possible to render a component (LocaleText) into href
            contact: state.app.texts['sidemenu.contact.link'],
            imprint: state.app.texts['sidemenu.imprint.link'],
            faq: state.app.texts['sidemenu.faq.link'],
            dataPrivacy: state.app.texts['sidemenu.data.privacy.link'],
        },
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setLocaleTexts: texts => dispatch(setLocaleTexts(texts)),
        setLocale: locale => dispatch(setLocale(locale)),
        setDealer: dealer => dispatch(setDealer(dealer)),
        setIsLoading: isLoading => dispatch(setIsLoading(isLoading)),
        toggleLanguageMenu: () => dispatch(toggleLanguageMenu()),
        toggleSideMenu: () => dispatch(toggleSideMenu()),
        toggleImprintPopup: () => dispatch(toggleImprintPopup()),
        toggleDataPrivacyPopup: () => dispatch(toggleDataPrivacyPopup()),
        toggleBrowserDetectPopup: () => dispatch(toggleBrowserDetectPopup()),
        toggleIntroductionLayer: () => dispatch(toggleIntroductionLayer()),
    };
}

const LayoutContainer = connect(mapStateToProps, mapDispatchToProps)(Layout);

export default LayoutContainer;
